import React, { useEffect, useState } from 'react';
import CustomButton from 'src/components/Actions/CustomButton';
import WalletIcon from 'src/assets/icons/Wallet';
import EmptyWallet from 'src/assets/icons/EmptyWallet';
import WalletWithMoney from 'src/assets/icons/WalletWithMoney';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';
import { useHistory } from 'react-router-dom';
import useGetWalletDetails from '../hooks/useGetWalletDetails';

export default function WalletPanel() {

  const { dspAccount } = useGetWalletDetails()

  const history = useHistory();
  const [walletBalance, setWalletBalance] = useState(0);
  const doGetWalletBalance = useApi(services.postService);

  useEffect(() => {
    if(dspAccount?.dspId){
      doGetWalletBalance.request({
        url: '/dsp/wallet-list',
        nodeAPI: 1,
        payload: {
          dspId: dspAccount?.dspId
  
          // ...(dspAccount?.dspId && {
          //   dspId: Number(dspAccount?.dspId)
          // })
        }
      });
    }
  }, [dspAccount]);

  useEffect(() => {
    const { loading, data } = doGetWalletBalance;
    if (!loading && data && data?.success === true && data?.data?.wallet_balance) {
      setWalletBalance(Number(data?.data?.wallet_balance));
    } else if (!loading && data && data?.success === false) {
      setWalletBalance(0);
    }
  }, [doGetWalletBalance.loading]);

  return (
    <React.Fragment>
      <section className="dsp-wallet-panel">
        {/* HEADER */}
        <h2 className="f-32 f-w-600 mb-2">Welcome to Amazon DSP </h2>
        <span className="f-16 f-w-400 f-1877F2 mb-5">Powered by Hector</span>
        {/* HEADER */}

        {/* BUTTON SECTION */}
        <div className="d-flex flex-md-row flex-column gap-15 mt-4">
          <div className="dsp-wallet-panel-outlined-btn">
            <WalletIcon />
            <span>Your Current balance is </span>
            <span>{formatCurrency(walletBalance)}</span>
          </div>
          <CustomButton
            primaryBtn
            fontWeight="600"
            padding="8px 20px"
            margin="0px"
            borderRadius="8px"
            minWidth="100px"
            onClick={() => {
              history.push('/dsp-payment');
            }}
          >
            <span className="f-20 mr-2">&#43;</span>
            Top Up Your Wallet
          </CustomButton>
        </div>
        {/* BUTTON SECTION */}

        {/* IMAGE SECTION */}
        {!doGetWalletBalance.loading && (
          <div className="d-flex align-items-center justify-content-center wallet-panel-abstract">
            {Number(walletBalance) == 0 ? <EmptyWallet /> : <WalletWithMoney />}
          </div>
        )}
        {/* IMAGE SECTION */}
      </section>
    </React.Fragment>
  );
}

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
  }).format(amount || 0);
};
